/**
 * Check if user has access to a given page
 * @param pagePath Page path to check
 */
export const hasConsentedDisclaimer = () => {
    const storageKey = "disclaimer";
    const consent = sessionStorage.getItem(storageKey) === "true";

    return consent;
};

/**
 * Checks whether access level for a page has been set,
 * useful when you need different handling depending on
 * if user has been explicitly denied or not been challenged yet
 * @param pagePath Page path to check
 */
export const isDisclaimerConsentSet = () => {
    const storageKey = "disclaimer";

    return sessionStorage.getItem(storageKey) !== null;
};

/**
 * Set access level for a page
 * @param pagePath Page path to set access level for
 * @param consent Specify whether user should have access or be denied
 */
export const setDisclaimerConsent = (consent: boolean) => {
    const storageKey = "disclaimer";
    sessionStorage.setItem(storageKey, consent.toString());

    return consent;
};